import * as json from "@/deploy/deploy.json";
export const deploy = json as { version: string };